export const fetchData = (stationCode) => {
  var packages = [
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId2",
      reason: "Delayed",
      act: "Action 2",
      promisedDate: "14-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
    {
      trackingId: "TrackingId1",
      reason: "unable to locate address",
      act: "Action 1",
      promisedDate: "13-12-2020",
      pastFail: "",
      remarks: "",
    },
  ];
  return packages;
};



// WEBPACK FOOTER //
// ./src/commons/api/PriorityPackagesAPI.js